import { ObjectValues } from '../types';

import { sizes as TextSizes } from '../text/text.types';

import type { AnchorHTMLAttributes } from 'react';

export const variants = {
  orange: 'orange',
} as const;

export const backgrounds = {
  defualt: 'default',
  fixed: 'fixed',
} as const;

export const sizes = {
  interface: TextSizes.interface,
  small: TextSizes.small,
  basic: TextSizes.basic,
  large: TextSizes.large,
};

export const iconPositions = {
  prefix: 'prefix',
  suffix: 'suffix',
};

export interface Link extends AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  icon?: React.ReactNode;
  testId?: string;
  text: string;
  variant?: ObjectValues<typeof variants>;
  background?: ObjectValues<typeof backgrounds>;
  size?: ObjectValues<typeof sizes>;
  iconPosition?: ObjectValues<typeof iconPositions>;
}
